import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicPageMutationKeys } from '../../../keys'
import { removeSectionFromPage } from '../../services'

interface UseMutationDeleteSectionFromPageProps {
	dynamicPageSectionId: string
}

export default function useMutationDeleteSectionFromPage(
	props?: UseBaseMutationOptions<void, UseMutationDeleteSectionFromPageProps>,
) {
	return useMutation({
		mutationKey: [DynamicPageMutationKeys.RemoveSectionFromPage],
		mutationFn: ({ dynamicPageSectionId }) =>
			removeSectionFromPage(dynamicPageSectionId),
		...props,
	})
}
